import { render, staticRenderFns } from "./VxTooltipWithSlotText.vue?vue&type=template&id=72b4c72e&"
import script from "./VxTooltipWithSlotText.vue?vue&type=script&lang=js&"
export * from "./VxTooltipWithSlotText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports